import { SvgProps } from 'models/svg';

const MapSvg = ({ className }: SvgProps) => {
  return (
    <svg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
      <path
        d='M12 1.625V9.875C12 10.1562 11.8359 10.4141 11.5781 10.5547L8.57812 12.0547C8.41406 12.125 8.20312 12.1484 8.01562 12.0781L3.79688 10.6953L1.07812 12.0547C0.84375 12.1719 0.585938 12.1484 0.351562 12.0078C0.140625 11.8672 0 11.6328 0 11.375V3.125C0 2.84375 0.164062 2.58594 0.421875 2.44531L3.42188 0.945312C3.58594 0.875 3.79688 0.851562 3.98438 0.921875L8.20312 2.32812L10.9219 0.945312C11.1562 0.828125 11.4141 0.851562 11.6484 0.992188C11.8594 1.13281 12 1.36719 12 1.625ZM4.5 9.33594L7.5 10.3438V3.66406L4.5 2.65625V9.33594Z'
        fill='#6C727F'
      />
    </svg>
  );
};

export default MapSvg;
